import { render, staticRenderFns } from "./VendorLookup.vue?vue&type=template&id=09740ed4&scoped=true&"
import script from "./VendorLookup.vue?vue&type=script&lang=js&"
export * from "./VendorLookup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09740ed4",
  null
  
)

export default component.exports